<template>
  <div class="modal_Single_Course">
    <p class="subheading">可购买章节</p>
    <ul class="courseList" v-if="videoList.length">
      <template v-for="(item,index) in videoList" :key="index">
        <li v-if="item.type === 2 && item.payStatus === 'F' && item.videoType !== 'O' && item.isTrial !== 'T'">
          <label class="item">
            <a-checkbox v-model:checked="item.active" @click="checked_fn(item)"/>
            <div class="info">
              <div class="box">
                <h3>{{item.video.name}}</h3>
                <p v-if="item.video.speakerList.length || item.video.vid">
                  <span v-for="(user, index) in item.video.speakerList" :key="index">{{ user.name }}</span>
                  <i v-if="item.video.vid">时长：{{ videoDuration(item.video.duration) }}</i>
                </p>
              </div>
              <!--toPayFor_n：支付类型（神贝或者￥），可不传-->
              <!--onlyPrice：用来判断是否显示价格 在支付页面只显示价格,不显示试看，可不传-->
              <CourseListType :data_videoInfo="data_videoInfo" :item="item"/>
            </div>
          </label>
        </li>
      </template>
    </ul>
    <div :class="`toPay_Single_Course ${isPay?'active':''}`" @click="toPaySeparate_fn">去支付</div>
  </div>
</template>
<script>
import { Checkbox } from "ant-design-vue";
import { videoDuration, getUserId } from "@/utils/methods.js";
import CourseListType from "@c/course/CourseListType";
export default {
  name: "VideoInfo",
  components: {
    [Checkbox.name]: Checkbox,
    CourseListType,
  },
  // type用来判断是否显示价格 在支付页面只显示价格
  props: ['data_videoInfo', 'type'],
  computed: {
    // 根据 秒 转成 分钟：秒
    videoDuration() {
      return (second) => {
        return videoDuration(second);
      };
    },
  },
  data () {
    return {
      videoList: [], // 视频列表
      isPay: false, // 是否可以支付
    }
  },
  methods: {
    filtrateDate(){
      this.isPay = false;
      this.videoList = this.data_videoInfo.normalCourseVideos;
      this.videoList.map(function(v){
        v.active = false;
      })
    },
    checked_fn(item){
      let hasActive = false;
      this.videoList.map(function(v){
        // 添加选中
        if(v.id === item.id){
          v.active = !v.active;
        }
        // 判断是否可支付
        if(v.active){
          hasActive = true;
        }
      })
      this.isPay = hasActive;
    },
    // 单独购买
    toPaySeparate_fn(){
      if(getUserId(true)){
        let payList = [];
        this.videoList.map(v=>{
          if(v.active){
            payList.push(v.id)
          }
        })
        this.$router.push({
          path: '/pages/orderPay/orderPay',
          query: {
            courseId: this.data_videoInfo.id,
            section: payList.join(',')
          }
        })
      }
    },
  },
  watch:{
    data_videoInfo(n,o){
      this.filtrateDate()
    }
  }
}
</script>

<style scoped lang="scss">
/* 单节课程弹窗 */
.modal_Single_Course {
  width: 862px;
  height: 60vh;
  padding: 22px 48px 22px 50px;
  display: flex;
  flex-direction: column;

  .subheading {
    font-size: 18px;
    margin-bottom: 10px;
  }

  .courseList {
    flex: 1;
    margin-bottom: 10px;
    overflow: auto;
    @extend %scrollStyle;

    li {
      display: flex;

      .item {
        display: flex;
        align-items: center;
        width: 100%;
        cursor: pointer;

        :deep(.ant-checkbox-inner) {
          border-radius: 50%;
        }

        :deep(.ant-checkbox) {
          &::after {
            border: none;
          }
        }

        .info {
          flex: 1;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #f0f0f0;
          padding: 15px;

          .box {
            flex: 1;
            margin-right: 15px;

            h3 {
              font-size: 16px;
            }

            p {
              font-size: 12px;
              margin-top: 8px;

              span{
                margin-right: 20px;
              }

              i {
                color: #646464;
              }
            }
          }

          .amount {
            display: flex;
            align-items: baseline;

            dd {
              font-size: 16px;
              color: #FF6624;
              display: flex;
              align-items: baseline;

              &:last-of-type {
                margin-left: 10px;
              }

              b {
                font-weight: bold;
                font-size: 22px;
              }
            }
          }
        }
      }
    }
  }

  .toPay_Single_Course {
    width: 162px;
    line-height: 44px;
    border-radius: 6px;
    color: #fff;
    background: rgba(5, 129, 206, 0.35);
    margin: auto auto 0;
    font-size: 16px;
    text-align: center;
    cursor: not-allowed;
    &.active{
      background: $theme_blue;
      cursor: pointer;
    }
  }
}
</style>
